import staggeredSlideUp from './staggeredSlideUp';

export default function loadAnimation(els: HTMLElement[]) {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const isMarkersEnabled = urlParams.get('enable_animation_markers') === 'true';

    els.forEach(el => {
        const containerEl = el.closest<HTMLElement>('[data-animation-container-el]');

        const animationType = el.getAttribute('data-load-animation');
        if (animationType === 'staggered-slide-up') {
            staggeredSlideUp(el, containerEl, isMarkersEnabled);
        }
        return;
    });
}
